import React, { useRef, useState, useEffect } from "react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { baseUrl } from "../Common/data";

export default function ChooseCollection() {
  const sliderRef = useRef();
  const navigate = useNavigate();

  const [collections, setCollections] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const scrollLeft = () => {
    sliderRef.current.scrollBy({ left: -350, behavior: "smooth" });
  };

  const scrollRight = () => {
    sliderRef.current.scrollBy({ left: 350, behavior: "smooth" });
  };

  useEffect(() => {
    const fetchCollections = async () => {
      setIsLoading(true);
      try {
        const response = await fetch(`${baseUrl}/api/property-collection/all`);
        const data = await response.json();

        if (data?.data) {
          const activeCollections = data.data
            .filter((item) => item.isActive)
            .sort((a, b) => a.name.localeCompare(b.name));
          setCollections(activeCollections);
        }

        // const response = await fetch(
        //   `${baseUrl}/api/selected-collection/valid`
        // );
        // const data = await response.json();
        // if (data?.data) {
        //   const sortedData = data.data.sort((a, b) =>
        //     a.collectionName.localeCompare(b.collectionName)
        //   );
        //   setCollections(sortedData);
        // }
      } catch (error) {
        console.error(error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchCollections();
  }, []);

  return (
    <section className="cc-section">
      {/* <div className="cc-header">
        <h2 className="cc-title">Top Collections</h2>
      </div> */}

      <div className="cc-slider-wrapper">
        <button className="cc-nav-btn cc-left-btn" onClick={scrollLeft}>
          <FaChevronLeft />
        </button>

        <div className="cc-slider" ref={sliderRef}>
          {collections.map((item) => (
            <div
              className="cc-card"
              key={item._id}
              onClick={() => navigate(`/property-collection/${item._id}`)}
            >
              <img
                src={item.image}
                alt={item.name}
                className="cc-img"
              />

              <div className="cc-overlay">
                <h3 className="cc-card-title">{item.name}</h3>
              </div>
            </div>
          ))}

          {/* 
          {collections.map((item) => (
            <div
              className="cc-card"
              key={item.collectionId}
              onClick={() =>
                navigate(`/search-results/collection/${item.collectionId}`)
              }
            >
              <img
                src={item.image}
                alt={item.collectionName}
                className="cc-img"
              />
              <div className="cc-overlay">
                <h3 className="cc-card-title">{item.collectionName}</h3>
              </div>
            </div>
          ))}
          */}
        </div>

        <button className="cc-nav-btn cc-right-btn" onClick={scrollRight}>
          <FaChevronRight />
        </button>
      </div>
    </section>
  );
}